.componentBadges {
  display: flex;
  margin: 0 calc(-1 * var(--space-xs));
}

.paramsBadges {
  display: inline;
  margin: 0;
}
